var redefine = require('../internals/redefine');

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/redefine-all.js
// module id = AsiA
// module chunks = 0